function QuotesView(props) {
	return <div className={(props.className || '')+' relative z-10 flex flex-col md:flex-row ml-10 mr-10 justify-center gap-12 md:gap-32'}>

		{
			[
				{
					text: 'The exhibit is state-of-the-art and mesmerizingly immersive, walking visitors through medieval life with style and even a sense of humor.',
					link: 'https://www.nytimes.com/interactive/2025/07/24/travel/things-to-do-reykjavik.html',
					linkText: 'The New York Times, 36 Hours in Reykjavík'
				},
				{
					text: 'We are not the first to tell these stories, from Marvel movies to bedtime stories, the tales of the manuscripts have taken on a multitude of lives.',
					link: 'https://www.scottishdesignawards.com/2025/experiential-design/world-in-words/',
					linkText: 'The Scottish Design Awards nomination'
				}
			].map((item, index) => <div key={index} className="text-center relative md:max-w-[35%]">
				
				<div className="mb-2 md:mb-3 relative">
					<div className="absolute top-[40px] left-[-30px] leading-[0] text-gray-300/60 text-[110px]">“</div>
					<div className="absolute bottom-[-20px] right-[-30px] leading-[0] text-gray-300/60 text-[110px]">”</div>
					<div className="relative text-md md:text-lg lg:text-xl italic z-5">{item.text}</div>
				</div>

				<hr className="border-gray-300 mb-3"/>
				
				<div><a className="text-md md:text-lg lg:text-xl text-sam_red relative z-5" href={item.link} target="_blank">{item.linkText}</a></div>

			</div>)
		}
		
	</div>
}

export default QuotesView;